import { axiosApi } from '@/api/axios';

export default {
  index(params) {
    return axiosApi.get('/dko_cooperation_requests', { params });
  },
  printCoordination(params) {
    return axiosApi.get('/dko_cooperation_requests/print_coordination', {
      params,
      skipNotFoundSnackbar: true,
    });
  },
  show(id) {
    return axiosApi.get(`/dko_cooperation_requests/${id}`);
  },
  create(payload) {
    return axiosApi.post('/dko_cooperation_requests', payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [(data) => data],
    });
  },
  update(id, payload) {
    return axiosApi.patch(`/dko_cooperation_requests/${id}`, payload);
  },
  actions(id) {
    return axiosApi.get(`/dko_cooperation_requests/${id}/actions`);
  },
  performAction(id, actionData) {
    return axiosApi.patch(`/dko_cooperation_requests/${id}/actions`, actionData);
  },
  createMember(payload) {
    return axiosApi.post('/dko_cooperation_request_members', payload);
  },
  deleteMember(id, listType) {
    return axiosApi.delete(`/dko_cooperation_request_members/${id}`, {
      data: { listType },
    });
  },
  candidateUsers() {
    return axiosApi.get('/users/simple_index');
  },
};
